import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import workStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/workStyle.jsx";

 const SectionTitle = ({title, classes}) =>
    <h2 className={classes.title}>{title}</h2>

export default withStyles(workStyle)(SectionTitle);